enum AlertType {
  Info = "info",
  Success = "success",
  Error = "error"
}

export { AlertType }
